import { httpClient } from "../../services/HttpClient";
import BankDetail from "../models/BankDetail";

const BASE_URL = "/system/bank-details";

export class BankDetailApi {

    private static getUrl(endpoint: string = ''): string {
        return `${BASE_URL}${endpoint}`;
    }

    static async find(bankDetailUuid: string): Promise<BankDetail> {
        const response = await httpClient.get(this.getUrl(`/${bankDetailUuid}`))

        return new BankDetail(response.data.data)
    }

    static async create(request: Record<string, any>): Promise<BankDetail> {
        const response = await httpClient.post(this.getUrl(), request)

        return new BankDetail(response.data.data)
    }

    static async edit(request: Record<string, any>, bankDetailUuid: string): Promise<BankDetail> {
        const response = await httpClient.patch(this.getUrl(`/${bankDetailUuid}`), request)

        return new BankDetail(response.data.data)
    }

    static async remove(bankDetailUuid: string): Promise<void> {
        return await httpClient.delete(this.getUrl(`/${bankDetailUuid}`))
    }
}